import ThumbsDown from './ThumbsDown';
import ThumbsUp from './ThumbsUp';
import classNames from 'classnames';

import { useContext } from 'react';
import { ComponentProps } from 'react';
import { Radio } from '@tymbe/components/inputs/radio';
import { TyRadio } from '@tymbe/ty-components/inputs/radio/Radio';
import TyRadioGroupContext from '@tymbe/components/inputs/radio/RadioGroupContext';

type ThumbValue = 'up' | 'down';

export type ThumbRadioProps = {
  variant?: ThumbValue;
  size?:number;
} & Omit<ComponentProps<typeof Radio>, 'label'>;

export const ThumbRadio= ({
  variant,
  className = '',
  size,
  ...props
}: ThumbRadioProps) => {

  const radioGroupContext = useContext(TyRadioGroupContext);
  if (!radioGroupContext) return null;

  const { radioGroupState } = radioGroupContext;
  const { value: groupValue } = radioGroupState;
  const checked = props.value === groupValue;

  return (
    <TyRadio
      className={classNames(
        className,
        '[&>input]:appearance-none flex items-center',
      )}
      required={false}
      label={variant === 'down' ? <ThumbsDown size={size} checked={checked}/> : <ThumbsUp size={size} checked={checked}/>}
      {...props}
    >
    </TyRadio>
  );
};
